<closeable-dialog class="ship-dialog-container">
  <div class="dialog-header" dialog-card-header>
    <span class="column-info content">{{ shipNo }}</span>
    <div class="badge" [ngClass]="'ship-badge-' + shipStatus"> {{ 'ship-badge-' + shipStatus | translate }}</div>
  </div>

  <div dialog-card-body class="dialog-body full-height">
    <div class="image-container">
      <img class="img1" src="assets/images/ship.png" *ngIf="!isRedImage || (activeTab !== 'motorInformation' && activeTab !== 'predictiveMaintenanceData') " />
      <img class="img2" src="assets/images/ship-red.png" *ngIf="isRedImage && (activeTab === 'motorInformation' || activeTab === 'predictiveMaintenanceData') " />
      <div class="depth-info" *ngIf="activeTab === 'generalInformation'">
        {{'depth' | translate}}
        <span style="color: white;">{{depth}}m</span>
      </div>
      <div class="heave-info" *ngIf="activeTab === 'generalInformation'">
        {{'heave' | translate}}
        <span style="color: white;">{{heave}}&deg;</span>
      </div>
      <div class="heaveRate-info" *ngIf="activeTab === 'generalInformation'">
        {{ 'heaveRate' | translate }}
        <span style="color: white;">{{ heaveRate }}&deg;/sn</span>
      </div>
      <div class="roll-info" *ngIf="activeTab === 'generalInformation'">
        {{'roll' | translate}}
        <span style="color: white;">{{roll}}&deg;</span>
      </div>
      <div class="rollRate-info" *ngIf="activeTab === 'generalInformation'">
        {{ 'rollRate' | translate }}
        <span style="color: white;">{{ rollRate }}&deg;/sn</span>
      </div>
      <div class="temperature-info" *ngIf="activeTab === 'ambientData'">
        {{'Temperature' | translate}}
        <img src="assets/images/temperature-icon.png" alt="Temperature Icon" class="icon" />
        <span style="color: white;">{{temperature}}&deg;C</span>
      </div>
      <div class="sea-temperature-info" *ngIf="activeTab === 'ambientData'">
        {{'seaWaterTemperature' | translate}}
        <img src="assets/images/sunny-icon.png" alt="Water Icon" class="icon" />
        <span style="color: white;">{{seaWaterTemperature}}&deg;C</span>
      </div>
    </div>

    <nb-tabset (changeTab)="onTabChange($event)">
      <nb-tab
        tabTitle="{{'generalInformation' | translate}}" [active]="activeTab === 'generalInformation'" [tabId]="'generalInformation'">
        <div class="d-flex ">
          <div class="flex-50">
            <label class="column-info title"> {{ 'currentDirection' | translate }} : </label>
            <label class="column-info content">{{ currentDirection }} &deg;</label>
          </div>
          <div [ngClass]="'flex-50'" [ngStyle]="{'margin-left':'25px'}">
            <label class="column-info title"> {{ 'heading' | translate }} : </label>
            <label class="column-info content">{{ heading }} &deg;</label>
          </div>
        </div>
        <div class="d-flex ">
          <div class="flex-50">
            <label class="column-info title"> {{ 'currentIntensity' | translate }} : </label>
            <label class="column-info content">{{ currentIntensity }} kts</label>
          </div>
          <div [ngClass]="'flex-50'" [ngStyle]="{'margin-left':'25px'}">
            <label class="column-info title"> {{ 'rateOfTurn' | translate }} : </label>
            <label class="column-info content">{{ rateOfTurn }} &deg;/sn</label>
          </div>
        </div>
        <div class="d-flex ">
          <div class="flex-50">
            <label class="column-info title"> {{ 'swell' | translate }} : </label>
            <label class="column-info content">{{ swell }} m</label>
          </div>
          <div [ngClass]="'flex-50'" [ngStyle]="{'margin-left':'25px'}">
            <label class="column-info title"> {{ 'courseOverGround' | translate }} : </label>
            <label class="column-info content">{{ courseOverGround }} &deg;</label>
          </div>
        </div>
        <div class="d-flex ">
          <div class="flex-50">
            <label class="column-info title"> {{ 'salinity' | translate }} : </label>
            <label class="column-info content">{{ salinity }} ppt</label>
          </div>
          <div [ngClass]="'flex-50'" [ngStyle]="{'margin-left':'25px'}">
            <label class="column-info title"> {{ 'speedOverGround' | translate }} : </label>
            <label class="column-info content">{{ speedOverGround }} kts</label>
          </div>
        </div>
        <div class="d-flex ">
          <div class="flex-50">
            <label class="column-info title"> {{ 'distance' | translate }} : </label>
            <label class="column-info content">{{ distance }} mil</label>
          </div>
          <div [ngClass]="'flex-50'" [ngStyle]="{'margin-left':'25px'}">
            <label class="column-info title"> {{ 'speedThroughWater' | translate }} : </label>
            <label class="column-info content">{{ speedThroughWater }} kts</label>
          </div>
        </div>
        <div class="d-flex ">
          <div class="flex-50">
            <label class="column-info title"> {{ 'pressure' | translate }} : </label>
            <label class="column-info content">{{ pressure }} mbar</label>
          </div>
        </div>
      </nb-tab>
      <nb-tab
        [tabIcon]=" isRedImage  ? {icon:'alert-triangle', options:{color:'#FF1F00'}} :{}"
        tabTitle="{{'motorInformation' | translate}}" [active]="activeTab === 'motorInformation'" [tabId]="'motorInformation'">
        <div class="d-flex ">
          <div class="flex-50">
            <label class="column-info caption"> {{ 'engine-1Information' | translate }} </label>
          </div>
          <div [ngClass]="'flex-50'" [ngStyle]="{'margin-left':'25px'}">
            <label class="column-info caption"> {{ 'engine-2Information' | translate }} </label>
          </div>
        </div>
        <div class="d-flex ">
          <div class="flex-50">
            <label class="column-info title"> {{ 'etcSpeedA1_1' | translate }} :</label>
            <label [ngClass]="'column-info content'+colorSignalStatus[0]">{{ etcSpeedA1_1 }} rpm</label>
          </div>
          <div [ngClass]="'flex-50'" [ngStyle]="{'margin-left':'25px'}">
            <label class="column-info title"> {{ 'etcSpeedA1_2' | translate }} :</label>
            <label class="column-info content">{{ etcSpeedA1_2 }} rpm</label>
          </div>
        </div>
        <div class="d-flex ">
          <div class="flex-50">
            <label class="column-info title"> {{ 'etcSpeedA2_1' | translate }} :</label>
            <label class="column-info content">{{ etcSpeedA2_1 }} rpm</label>
          </div>
          <div [ngClass]="'flex-50'" [ngStyle]="{'margin-left':'25px'}">
            <label class="column-info title"> {{ 'etcSpeedA2_2' | translate }}: </label>
            <label class="column-info content">{{ etcSpeedA2_2 }} rpm</label>
          </div>
        </div>
        <div class="d-flex ">
          <div class="flex-50">
            <label class="column-info title"> {{ 'etcSpeedB1_1' | translate }}: </label>
            <label class="column-info content">{{ etcSpeedB1_1 }} rpm</label>
          </div>
          <div [ngClass]="'flex-50'" [ngStyle]="{'margin-left':'25px'}">
            <label class="column-info title"> {{ 'etcSpeedB1_2' | translate }} :</label>
            <label [ngClass]="'column-info content'+colorSignalStatus[2]">{{ etcSpeedB1_2 }} rpm</label>
          </div>
        </div>
        <div class="d-flex ">
          <div class="flex-50">
            <label class="column-info title"> {{ 'etcSpeedB2_1' | translate }}: </label>
            <label class="column-info content">{{ etcSpeedB2_1 }} rpm</label>
          </div>
          <div [ngClass]="'flex-50'" [ngStyle]="{'margin-left':'25px'}">
            <label class="column-info title"> {{ 'etcSpeedB2_2' | translate }}: </label>
            <label [ngClass]="'column-info content'+colorSignalStatus[3]">{{ etcSpeedB2_2 }} rpm</label>
          </div>
        </div>
        <div class="d-flex">
          <div class="flex-50"></div>
          <div [ngClass]="'flex-50'" [ngStyle]="{'margin-left':'25px'}">
            <label class="column-info title">{{ 'engineSpeed' | translate }}:</label>
            <label class="column-info content">{{ engineSpeed }} rpm</label>
          </div>
        </div>
        <div class="d-flex">
          <div class="flex-50"></div>
          <div [ngClass]="'flex-50'" [ngStyle]="{'margin-left':'25px'}">
            <label class="column-info title">{{ 'fuelRackPosition' | translate }}:</label>
            <label class="column-info content">{{ fuelRackPosition }}</label>
          </div>
        </div>
        <hr class="custom-line">
        <div class="d-flex ">
          <div class="flex-50">
            <label class="column-info caption"> {{ 'engine-1ExhauseTemperature' | translate }} </label>
          </div>
          <div [ngClass]="'flex-50'" [ngStyle]="{'margin-left':'25px'}"></div>
        </div>
        <div class="d-flex ">
          <div class="flex-50">
            <label class="column-info title"> {{ 'tExhaustA1' | translate }}: </label>
            <label class="column-info content" >{{ tExhaustA1 }} &deg;C</label>
          </div>
          <div [ngClass]="'flex-50'" [ngStyle]="{'margin-left':'25px'}">
            <label class="column-info title"> {{ 'tExhaustB1' | translate }}: </label>
            <label class="column-info content">{{ tExhaustB1 }} &deg;C</label>
          </div>
        </div>
        <div class="d-flex ">
          <div class="flex-50">
            <label class="column-info title"> {{ 'tExhaustA2' | translate }}: </label>
            <label class="column-info content">{{ tExhaustA2 }} &deg;C</label>
          </div>
          <div [ngClass]="'flex-50'" [ngStyle]="{'margin-left':'25px'}">
            <label class="column-info title"> {{ 'tExhaustB2' | translate }}: </label>
            <label class="column-info content">{{ tExhaustB2 }} &deg;C</label>
          </div>
        </div>
        <div class="d-flex ">
          <div class="flex-50">
            <label class="column-info title"> {{ 'tExhaustA3' | translate }}: </label>
            <label class="column-info content">{{ tExhaustA3 }} &deg;C</label>
          </div>
          <div [ngClass]="'flex-50'" [ngStyle]="{'margin-left':'25px'}">
            <label class="column-info title"> {{ 'tExhaustB3' | translate }}: </label>
            <label class="column-info content">{{ tExhaustB3 }} &deg;C</label>
          </div>
        </div>
        <div class="d-flex ">
          <div class="flex-50">
            <label class="column-info title"> {{ 'tExhaustA4' | translate }}: </label>
            <label class="column-info content">{{ tExhaustA4 }} &deg;C</label>
          </div>
          <div [ngClass]="'flex-50'" [ngStyle]="{'margin-left':'25px'}">
            <label class="column-info title"> {{ 'tExhaustB4' | translate }}: </label>
            <label class="column-info content">{{ tExhaustB4 }} &deg;C</label>
          </div>
        </div>
        <div class="d-flex ">
          <div class="flex-50">
            <label class="column-info title"> {{ 'tExhaustA5' | translate }}: </label>
            <label class="column-info content">{{ tExhaustA5 }} &deg;C</label>
          </div>
          <div [ngClass]="'flex-50'" [ngStyle]="{'margin-left':'25px'}">
            <label class="column-info title"> {{ 'tExhaustB5' | translate }}: </label>
            <label class="column-info content">{{ tExhaustB5 }} &deg;C</label>
          </div>
        </div>
        <div class="d-flex ">
          <div class="flex-50">
            <label class="column-info title"> {{ 'tExhaustA6' | translate }}: </label>
            <label class="column-info content">{{ tExhaustA6 }} &deg;C</label>
          </div>
          <div [ngClass]="'flex-50'" [ngStyle]="{'margin-left':'25px'}">
            <label class="column-info title"> {{ 'tExhaustB6' | translate }}: </label>
            <label class="column-info content">{{ tExhaustB6 }} &deg;C</label>
          </div>
        </div>
        <div class="d-flex ">
          <div class="flex-50">
            <label class="column-info title"> {{ 'tExhaustA7' | translate }}: </label>
            <label class="column-info content">{{ tExhaustA7 }} &deg;C</label>
          </div>
          <div [ngClass]="'flex-50'" [ngStyle]="{'margin-left':'25px'}">
            <label class="column-info title"> {{ 'tExhaustB7' | translate }}: </label>
            <label class="column-info content">{{ tExhaustB7 }} &deg;C</label>
          </div>
        </div>
        <div class="d-flex ">
          <div class="flex-50">
            <label class="column-info title"> {{ 'tExhaustA8' | translate }}: </label>
            <label class="column-info content">{{ tExhaustA8 }} &deg;C</label>
          </div>
          <div [ngClass]="'flex-50'" [ngStyle]="{'margin-left':'25px'}">
            <label class="column-info title"> {{ 'tExhaustB8' | translate }}: </label>
            <label class="column-info content">{{ tExhaustB8 }} &deg;C</label>
          </div>
        </div>
        <hr class="custom-line">
        <div class="d-flex ">
          <div class="flex-50">
            <label class="column-info caption"> {{ 'lubricatingOilFuelInformation' | translate }} </label>
          </div>
          <div [ngClass]="'flex-50'" [ngStyle]="{'margin-left':'25px'}">
            <label class="column-info caption"> {{ 'coolingWaterInformation' | translate }} </label>
          </div>
        </div>
        <div class="d-flex ">
          <div class="flex-50">
            <label class="column-info title"> {{ 'tLubeOil' | translate }}: </label>
            <label class="column-info content" >{{ tLubeOil }} &deg;C</label>
          </div>
          <div [ngClass]="'flex-50'" [ngStyle]="{'margin-left':'25px'}">
            <label class="column-info title"> {{ 'tCoolant' | translate }}: </label>
            <label [ngClass]="'column-info content'+colorSignalStatus[1]">{{ tCoolant }} &deg;C</label>
          </div>
        </div>
        <div class="d-flex ">
          <div class="flex-50">
            <label class="column-info title"> {{ 'tFuel' | translate }}: </label>
            <label class="column-info content" >{{ tFuel }} &deg;C</label>
          </div>
          <div [ngClass]="'flex-50'" [ngStyle]="{'margin-left':'25px'}">
            <label class="column-info title"> {{ 'pCoolant' | translate }}: </label>
            <label [ngClass]="'column-info content'+colorSignalStatus[1]">{{ pCoolant }} bar</label>
          </div>
        </div>
        <div class="d-flex ">
          <div class="flex-50">
            <label class="column-info title"> {{ 'pLubeOilFilterDiff' | translate }} :</label>
            <label class="column-info content">{{ pLubeOilFilterDiff }} bar</label>
          </div>
          <div [ngClass]="'flex-50'" [ngStyle]="{'margin-left':'25px'}">
            <label class="column-info title"> {{ 'coolantLevel' | translate }}: </label>
            <label class="column-info content">{{ coolantLevel }}</label>
          </div>
        </div>
        <div class="d-flex ">
          <div class="flex-50">
            <label class="column-info title"> {{ 'pLubeOilETC' | translate }}: </label>
            <label class="column-info content">{{ pLubeOilETC }} bar</label>
          </div>
          <div class="flex-50"></div>
        </div>
        <div class="d-flex ">
          <div class="flex-50">
            <label class="column-info title"> {{ 'pControlAir' | translate }}: </label>
            <label class="column-info content">{{ pControlAir }} bar</label>
          </div>
          <div class="flex-50"></div>
        </div>
      </nb-tab>
      <nb-tab
        tabTitle="{{'ambientData' | translate}}" [active]="activeTab === 'ambientData'" [tabId]="'ambientData'">
          <div class="d-flex ">
            <label class="column-info title"> {{ 'relativeWindSpeed' | translate }} :</label>
            <label [ngClass]="'column-info content'"> {{ relativeWindSpeed }} kts </label>
          </div>
          <div class="d-flex ">
            <label class="column-info title"> {{ 'relativeWindDirection' | translate }} : </label>
            <label class="column-info content">{{ relativeWindDirection }} &deg;</label>
          </div>
          <div class="d-flex ">
            <label class="column-info title"> {{ 'cloudHeight' | translate }} :</label>
            <label class="column-info content">{{ cloudHeight }} m</label>
          </div>
        <div class="d-flex ">
            <label class="column-info title"> {{ 'rainfallAmount' | translate }} :</label>
            <label class="column-info content">{{ rainfallAmount }} mm/s</label>
          </div>
          <div class="d-flex ">
            <label class="column-info title"> {{ 'humidity' | translate }} : </label>
            <label class="column-info content">{{ humidity }} %</label>
          </div>
          <div class="d-flex ">
            <label class="column-info title"> {{ 'radiation' | translate }} :</label>
            <label class="column-info content">{{ radiation }} W/m2</label>
          </div>
      </nb-tab>
      <nb-tab
        [tabIcon]=" isRedImage  ? {icon:'alert-triangle', options:{color:'#FF1F00'}} :{}"
        tabTitle="{{'predictiveMaintenanceData' | translate}}" [active]="activeTab === 'predictiveMaintenanceData'" [tabId]="'predictiveMaintenanceData'">
        <div class="d-flex ">
          <label [ngClass]="'column-info content' + colorStatus"> {{ 'ship-predictiveMaintenance-' + status | translate}}</label>
        </div>
      </nb-tab>
    </nb-tabset>
  </div>
  <div dialog-card-footer class="footer">
    <div dialog-card-footer class="footer-left">
      <label class="column-info title">{{ 'latitude' | translate }}: &nbsp;</label>
      <label class="column-info content">{{ locationShip[0] }}</label>
      <label class="column-info title" [ngStyle]="{'margin-left':'10px'}">{{ 'longitude' | translate }}: &nbsp;</label>
      <label class="column-info content">{{ locationShip[1] }}</label>
    </div>
    <div dialog-card-footer class="footer-right">
      <label class="column-info title">{{ 'lastUpdatedTime' | translate }}: &nbsp;</label>
      <label class="column-info content">{{ lastUpdatedTime }}</label>
    </div>
  </div>
</closeable-dialog>
